import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { Button } from 'antd';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { DownloadStoriesPreviewModel, InstagramPostTemplateDataModel } from '@/types/home';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';

const InstagramActivityTrackerContent = ({
  contentData,
  isTracker = false,
  webBg = 'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg.webp',
  phoneBg = 'https://res-front.pumpsoul.com/ins-prod/image/phone_stories_trust_bg.webp',
}: {
  contentData?: DownloadStoriesPreviewModel | InstagramPostTemplateDataModel;
  isTracker?: boolean;
  webBg?: string;
  phoneBg?: string;
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const section5 = contentData?.contentInfo?.['section-5'];
  const { width } = useWindowSize();

  return section5 ? (
    <div
      className={classNames([styles.content, isTracker && styles.trackerContent])}
      style={{ backgroundImage: `url("${width > 768 ? webBg : phoneBg}")` }}
    >
      {section5?.title && <div className={styles.title}>{section5?.title}</div>}

      {section5?.desc && (
        <>
          {Array.isArray(section5?.desc) ? (
            section5?.desc?.map((item, index) => (
              <p className={styles.desc} key={index}>
                {item}
              </p>
            ))
          ) : (
            <p className={styles.desc}>{section5?.desc}</p>
          )}
        </>
      )}

      {section5?.options?.length > 0 && !isTracker && (
        <div className={styles.itemList}>
          {section5?.options?.map((item, index) => {
            return (
              <div key={item} className={styles.item}>
                <Image src={'/images/toolkit/checked_icon.webp'} alt="" width={20} height={20} />
                <span>{item}</span>
              </div>
            );
          })}
        </div>
      )}

      {!isTracker && (
        <div className={styles.bottomContainer}>
          <Button
            className={styles.btn}
            onClick={() => {
              ga_logEvent(EventName.WebViewerforInstagram_AddAccountToTrack);
              router.push(`/dashboard?alertType=1`);
            }}
          >
            {t('Add Account to Track')}
          </Button>

          <div className={styles.anonymousContainer}>
            <span>{t('100% Anonymous')}</span>
            <Image src="/images/freetools/warranty-icon.webp" alt={''} width={20} height={20} />
          </div>
        </div>
      )}
    </div>
  ) : null;
};

export default InstagramActivityTrackerContent;
